import { EntityStatus } from './entity-status.model';
export class UpdateClassStatusesReq {
  dateFrom: Date;

  isFilters: boolean;

  groupIds: string[];
  courseIds: string[];
  coachIds: string[];
  roomIds: string[];
  trainingCategoryIds: string[];
  levels: string[];

  entityStatus: EntityStatus;
}
